var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { useImage } from '../hooks/use-image';
import { classNames } from '@shapeable/utils';
var cls = classNames('image');
import { omit } from 'lodash';
/**
 * This component is needed so that we can turn it into a styled component
 * (Given that styled components are defined outside of the body of a React.FC)
 */
export var Image = function (props) {
  var Image = useImage();
  return /* @ts-ignore */(
    React.createElement(Image, __assign({}, omit(props, 'hasPortrait', 'hasLandscape', 'hasTablet', 'hasLarge')))
  );
};